import script from "./ContributorFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorFields.vue?vue&type=script&setup=true&lang=js"

import "./ContributorFields.vue?vue&type=style&index=0&id=37a338f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a338f9"]])

export default __exports__